import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ApiService } from "@app/services/api.service";
import { SearchService } from "@app/services/search.service";
import { ISearchScope, SearchController } from "@app/views/search.view";
import { ICustomer, ISavedSearch, meta } from "@models";
import { icons } from "@tools";

export interface ICustomersScope extends ISearchScope<ICustomer> {
    fixUrl: (url: string) => string;
}

@NgView({
    token: Token.CustomersView,
    inherit: [Token.SearchView]
})
export class CustomersController extends SearchController<ICustomer> {
    constructor(
        $scope: ICustomersScope,
        agg: SearchService
    ) {

        super(
            $scope,
            agg
        );

        agg.$rootScope.setTitle(loc.customers);

        agg.drawerService.pageTitle = loc.customers;
        agg.drawerService.pageIcon = icons.users;

        agg.drawerService.setHelpUrl("Customers");

        if (agg.$rootScope.user.canModifyCustomers) {
            agg.drawerService.addDrawer(icons.add, loc.add, () => agg.$state.go("kb.customerNew"));
            agg.drawerService.addDrawer(icons.clone, loc.clone, () => this.clone());
            agg.drawerService.addDrawer(icons.deleter, loc.deleter, () => this.deleteItems());
        }
                            
        $scope.fixUrl = url => {
            if (url && !url.startsWith("http")) url = "http://" + url;
            return url;
        };
    }
    
    public client(api: ApiService) {
        return api.customers;
    }

    public newSearch(): ISavedSearch {
        return {
            modelType: meta.Customer.$name,
            sortField: "name",
            descending: false,
            filters: this.getFiltersFromMeta(meta.Customer.$name, true),
            roles: []
        };
    }
}
